export const CLIENT_BECAME_OUTDATED = "versionSync/CLIENT_BECAME_OUTDATED";
export const VERSION_MISMATCH_MODAL_DISMISSED = 'versionSync/VERSION_MISMATCH_MODAL_DISMISSED';